/**
 * @desc 根据条件获取成本中心列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.CostCenterListResponseDto>>;
export function request(
  body: defs.basics.CostCenterListRpcRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/rpc/costCenter/getCostCenterList`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
